import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import {
    FaExternalLinkAlt, FaAndroid, FaApple, FaCog, FaPlus,
} from 'react-icons/fa';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import LoginButton from '@appblocks/frontend/client/Components/LoginButton';
import WorkspaceView from '@appblocks/frontend/client/Components/WorkspaceView';
import NavAccordion from '@appblocks/frontend/client/Components/NavAccordion';


export default function Sidenav(props) {
    const userState = useSelector(state => state.user);

    const navItems = [
        {
            name: 'Home',
            path: '/',
            type: 'link',
            exact: true,
        },
        {
            name: 'AppBlocks Designer (ABD)',
            type: 'category',
            items: [
                {
                    name: 'Applications',
                    path: '/apps',
                    exact: true,
                },
            ],
        },
        {
            name: 'AppBlocks Cloud (ABC)',
            type: 'category',
            beta: true,
            auth: true,
            items: [
                {
                    name: 'Devices',
                    path: '/devices',
                },
                {
                    name: 'Device Groups',
                    path: '/groups',
                },
                // {
                //     name: 'Pages',
                //     path: '/pages',
                // },
                {
                    name: 'Workflows',
                    path: '/workflows',
                },
                {
                    name: 'Events',
                    path: '/events',
                },
                // {
                //     name: 'DataSources',
                //     path: '/datasources',
                // },

                // {
                //     name: 'Firmware',
                //     path: '/firmware',
                // },
            ],
        },
        {
            name: 'Resources',
            type: 'category',
            items: [
                {
                    name: 'Settings',
                    type: 'link',
                    path: '/settings',
                    auth: true,
                },
                {
                    name: 'Blog',
                    path: `${process.env.HOME_URL}/blog`,
                },
                {
                    name: 'Tutorials',
                    path: `${process.env.HOME_URL}/tutorials/introduction`,
                },
                {
                    name: 'Documentation',
                    path: `${process.env.HOME_URL}/docs/intro`,
                },
                {
                    name: 'Downloads',
                    path: `${process.env.HOME_URL}/downloads`,
                },
                {
                    name: 'Feedback',
                    path: 'https://appblocks.canny.io/feedback',
                },
            ],
        },
    ];

    const renderLink = (item) => {
        if (item.auth && !userState.user) {
            return;
        }
        return (
            <li className="nav-item" key={item.name}>
                {item.path.indexOf('http') !== 0 ? (
                    <NavLink
                        to={item.path}
                        className="nav-link mt-2"
                        exact={item.exact}
                        activeClassName="active"
                    >
                        {item.name}
                    </NavLink>
                ) : (
                    <a
                        href={item.path}
                        className="nav-link mt-2"
                        target="_blank"
                        rel="noreferrer"
                    >
                        {item.name}
                        <FaExternalLinkAlt className="ms-1" />
                    </a>
                )}
            </li>
        );
    };

    return (
        <div className="navbar-vertical d-flex flex-column flex-shrink-0 p-3 border-end">
            <Navbar.Brand
                as={Link}
                to="/"
            // className="text-center"
            >
                <img
                    className="header-logo"
                    alt="Cody"
                    src="/static/img/app_blocks_logo.svg"
                />
            </Navbar.Brand>
            <hr />

            <ul className="nav nav-pills flex-column mb-auto">
                {navItems.map((item, index) => {
                    if (item.auth && !userState.user) {
                        return;
                    }
                    if (item.items === undefined) {
                        return renderLink(item);
                    }
                    return (
                        <li className="nav-item" key={index}>
                            <div
                                className="mt-3"
                            >
                                <strong>{item.name}</strong>
                                {item.beta && (
                                    <span className="badge bg-success ms-2">Beta</span>
                                )}
                            </div>
                            <ul className="nav nav-pills flex-column mb-auto">
                                {item.items.map((subItem, subIndex) => renderLink(subItem))}
                            </ul>
                        </li>
                    );
                })}

                {/* <Accordion defaultActiveKey="1">
                    <NavAccordion eventKey="0">Resources</NavAccordion>
                    <Accordion.Collapse eventKey="0" className="bg-light">
                        <>
                            <li className="nav-item">
                                <a
                                    href={`${process.env.HOME_URL}/blog`}
                                    className="nav-link mt-2"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Blog
                                </a>
                            </li>
                            <li className="nav-item">
                                <a
                                    href={`${process.env.HOME_URL}/docs/intro`}
                                    className="nav-link mt-2"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Documentation
                                </a>
                            </li>
                            <li className="nav-item">
                                <a
                                    href={`${process.env.HOME_URL}/downloads`}
                                    className="nav-link mt-2"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Downloads
                                </a>
                            </li>
                            <li className="nav-item">
                                <a
                                    href="https://appblocks.canny.io/feedback"
                                    className="nav-link mt-2"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Feedback
                                </a>
                            </li>
                        </>
                    </Accordion.Collapse>
                </Accordion> */}

                <Accordion className="" defaultActiveKey="1">


                    {/* <Accordion.Item eventKey="0">
                        <Accordion.Header>
                            <li className="nav-item">
                                <div className="nav-link mt-2">
                                    Resources
                                </div>
                            </li>
                        </Accordion.Header>
                        <Accordion.Body>
                            <li className="nav-item">
                                <a
                                    href={`${process.env.HOME_URL}/blog`}
                                    className="nav-link mt-2"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Blog
                                </a>
                            </li>
                            <li className="nav-item">
                                <a
                                    href={`${process.env.HOME_URL}/docs/intro`}
                                    className="nav-link mt-2"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Documentation
                                </a>
                            </li>
                            <li className="nav-item">
                                <a
                                    href={`${process.env.HOME_URL}/downloads`}
                                    className="nav-link mt-2"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Downloads
                                </a>
                            </li>
                            <li className="nav-item">
                                <a
                                    href="https://appblocks.canny.io/feedback"
                                    className="nav-link mt-2"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Feedback
                                </a>
                            </li>
                        </Accordion.Body>
                    </Accordion.Item> */}
                </Accordion>
            </ul>
            <hr />
            <Nav className="align-items-center">
                <LoginButton />
                {userState.user && (
                    <div>
                        <div className="nav ms-3">
                            {userState.user.email}
                        </div>
                        <WorkspaceView />
                    </div>
                )}
            </Nav>
        </div>

    );
}
